/**
 * Funnel analytics for public forms (added 2026-10-09). Reports how far a
 * visitor got -- which fields were filled and where they stopped -- never
 * what they typed (see models.FormSession on the backend for why). Fire
 * and forget: a failed ping must never affect the form.
 */
export type FormEventName = 'view' | 'progress' | 'error' | 'submitted'

export function newFormSessionId(): string {
  const bytes = new Uint8Array(12)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

export function trackFormEvent(event: {
  sessionId: string
  form: string
  source: string
  event: FormEventName
  fieldsFilled?: string[]
  lastField?: string
}): void {
  try {
    void fetch('/api/v1/analytics/form-events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: event.sessionId,
        form: event.form,
        source: event.source,
        event: event.event,
        fields_filled: event.fieldsFilled ?? [],
        last_field: event.lastField ?? null,
      }),
      keepalive: true,
    }).catch(() => undefined)
  } catch {
    // analytics must never break the form
  }
}
